<main class="container-geral-metas">
  <section class="cabecalho">
      <div class="d-flex">
          <h1 id="titulo-pagina" class="titulo fonte-DM-Sans m-0">{{ "COMPONENTS.METAS.title" | transloco }}</h1>
          <button *ngIf="permissoes.criar" class="botao-cadastrar" routerLink="cadastro">+</button>
      </div>
  </section>
  <section class="mb-4">
    <div class="row">
      <div class="col-md-4">
        <p class="fonte-DM-Sans m-0 titulo-meta">{{this.meta?.vc_nome}}</p>
        <p class="fonte-DM-Sans m-0 legenda-ultima-atualizacao" *ngIf="this.meta?.ultima_atualizacao">{{ "COMPONENTS.METAS.lastUpdate" | transloco }}: {{this.meta?.ultima_atualizacao | date: 'dd/MM/yyyy HH:mm'}}</p>
      </div>
      <div class="col-md-8 d-flex justify-content-end gap-3 align-items-end">
        <app-filtro-clientes (carregarCliente)="buscarMetas($event)"></app-filtro-clientes>

        <div class="container-filtro altura-padrao-filtro">
          <object class="icone-filtro" data="assets/icones-filtros/icone-metas-alvo.svg" type="image/svg+xml"></object>
          <select id="filtro-meta" class="crud-select form-select" #selectMetas>
            @if (metas.length > 0) {
              <option id="placeholder-metas" value="" disabled selected>{{ placeholderMetas | transloco }}</option>

              @for (meta of metas; track meta.sr_id) {
                <option [value]="meta.sr_id" [selected]="meta.sr_id === ultimaMetaVisualizada.sr_id">
                  {{meta.vc_nome}}
                </option>
              }
            } @else {
              <option id="placeholder-metas" value="" selected>{{ placeholderMetas | transloco }}</option>
            }
          </select>
        </div>
        <button type="button" class="botao-filtrar fonte-DM-Sans" (click)="onFiltrar(selectMetas.value)">{{ "COMPONENTS.METAS.filterButton" | transloco }}</button>
      </div>
    </div>
    </section>
    <div *ngIf="!metas || !meta && !loading" class="d-flex justify-content-center py-5 text-secondary">{{ "COMPONENTS.METAS.noGoalFound" | transloco }}</div>
    <section *ngIf="meta">
      <div class="row">

        <div class="col-md-6">
          <div class="row mb-4">
            <div class="col-md-12 p-0" id="previsao-produtividade">
              <div class="container-produtividade d-flex align-items-stretch justify-content-center gap-4">
                <div class="card-previsao">
                  <div class="titulo">{{ "COMPONENTS.METAS.forecast.title" | transloco }}</div>
                  <div class="valor"> {{this.meta.previsao_produtividade?.previsao}} HA</div>
                  <div class="status" *ngIf="this.meta?.previsao_produtividade?.abaixo_da_meta">{{ "COMPONENTS.METAS.forecast.belowDailyGoal" | transloco }}</div>
                </div>
                <div class="card-produtividade">
                  <div class="row produzido">
                    <span>{{ "COMPONENTS.METAS.forecast.produced" | transloco }}</span>
                    <span>{{this.meta.indice_produtividade?.produzido}} HA<span class="asterisco-descricao">*</span></span>
                  </div>
                  <div class="row ideal">
                    <span>{{ "COMPONENTS.METAS.forecast.belowIdeal" | transloco }}</span>
                    <span>{{this.meta.indice_produtividade?.abaixo}} HA<span class="asterisco-descricao">*</span></span>
                  </div>
                  <div class="row irrigado">
                    <span>{{ "COMPONENTS.METAS.forecast.shouldHavePlanted" | transloco }}</span>
                    <span>{{this.meta.indice_produtividade?.ideal_dia}} HA<span class="asterisco-descricao">*</span></span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row p-0">
            <div class="col-md-12 p-0">
              <div class="container-metas" id="graficos-meta">
                <h2 class="titulo">{{ "COMPONENTS.METAS.goals.title" | transloco }}</h2>
                <div class="row mb-5">
                  <div class="col-md-6">
                    <h4 class="datas">{{meta.dt_inicio_meta | date: (linguagemPreferida == 'en' ? 'MM/dd/yyyy' : 'dd/MM/yyyy')}} - {{meta.dt_fim_meta | date:(linguagemPreferida == 'en' ? 'MM/dd/yyyy' : 'dd/MM/yyyy')}}</h4>
                  </div>
                  <div class="col-md-6 d-flex justify-content-end" id="acoes">
                    <button *ngIf="permissoes.excluir" class="btn-excluir no-wrap" (click)="excluir(meta.sr_id!)">
                      <img src="../../../../assets/metas/lixo.svg" alt="Lixeira"> {{ "COMPONENTS.METAS.goals.deleteGoal" | transloco }}
                    </button>

                    <button class="btn-exportar no-wrap" (click)="exportarPDF()">
                        <img src="../../../../assets/metas/exportar-metas.svg" alt="Exportar"> {{ "COMPONENTS.METAS.goals.export" | transloco }}
                    </button>
                  </div>
                </div>
                <app-barra-progresso
                  [metaTotal]="meta.metas.fl_meta_total"
                  [metaReal]="meta.indice_produtividade?.total || 0"
                  [metaIdeal]="meta.indice_produtividade?.ideal_meta || 0">
                </app-barra-progresso>
                <div id="grafico-metas" class="d-flex gap-3 justify-content-between" *ngIf="meta">
                  <app-media-grafico
                    corIcone="#FA5A7D" corFundo="#FFE2E5"
                    srcIcone="../../../../../assets/metas/dia.svg"
                    [titulo]="'COMPONENTS.METAS.goals.perDay' | transloco" [meta]="meta.metas.fl_meta_dia" [real]="meta.indice_produtividade?.produzido || 0"
                  ></app-media-grafico>

                  <app-media-grafico
                    corIcone="#FF947A" corFundo="#FFF4DE"
                    srcIcone="../../../../../assets/metas/hora.svg"
                    [titulo]="'COMPONENTS.METAS.goals.perHour' | transloco" [meta]="meta.metas.fl_meta_hora" [real]="meta.media_produtividade.hora"
                  ></app-media-grafico>

                  <app-media-grafico
                    corIcone="#3CD856" corFundo="#DCFCE7"
                    srcIcone="../../../../../assets/metas/semana.svg"
                    [titulo]="'COMPONENTS.METAS.goals.perWeek' | transloco" [meta]="meta.metas.fl_meta_semana" [real]="meta.media_produtividade.semana"
                  ></app-media-grafico>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div class="container-turnos" id="container-turnos">
            <h2 class="titulo">{{ "COMPONENTS.METAS.shifts.title" | transloco }}</h2>
            <ng-container *ngFor="let turno of meta.produtividade_por_turnos; let i = index">
              <app-barra-progresso
                [titulo]="turno.vc_nome"
                [metaTotal]="turno.meta_total"
                [metaReal]="turno.meta_real"
                [metaIdeal]="turno.meta_ideal"
                [corBarra]="retornaCorTurno('barra', i)"
                [corReal]="retornaCorTurno('real', i)"
                [corIdeal]="retornaCorTurno('ideal', i)">
              </app-barra-progresso>
            </ng-container>
          </div>
          <div class="container-metas px-4 mx-4" id="dialog-top-operadores">
            <div class="row">
              <div class="col-md-6">
                <h2 class="titulo">{{ "COMPONENTS.METAS.topOperators.title" | transloco }}</h2>
              </div>
              <div class="col-md-6 d-flex justify-content-end">
                <button class="btn-expandir" (click)="abrirDialogTopOperadores()">
                  <img src="../../../../../assets/metas/expandir.svg" alt="Expandir Resultados">
                </button>
              </div>
            </div>
            <app-dialog-top-operadores
              [topOperadoresLimitado]="dataSourceLimited.data"
              [modal]="false">
            </app-dialog-top-operadores>
          </div>
          <div class="mensagem-descricao-valores">{{ "COMPONENTS.METAS.approximateValues" | transloco }}</div>
        </div>
      </div>

    </section>
</main>
